import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Spinner,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { addpackageCategory } from "../../store/slices/packagecategory";

export default function AddCategory() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialForm = {
    name: "",
  };

  const [form, setForm] = useState(initialForm);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => {
      const newErrors = { ...prev };

      switch (name) {
        case "name":
          if (!value.trim()) newErrors.name = "Please enter category name";
          else delete newErrors.name;
          break;

        default:
          break;
      }

      return newErrors;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!form.name.trim()) newErrors.name = "Please enter category name";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    try {
      setLoading(true);

      const payload = {
        name: form.name.trim(),
      };

      await dispatch(addpackageCategory(payload)).unwrap();

      toast.success("Category added successfully");

      setForm(initialForm);
      setErrors({});

      navigate("/admin/category");
    } catch (err) {
      toast.error(err || err?.message || "Failed to add cateegory");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link active"
            onClick={() => navigate("/admin/category")}
          >
            Category
          </span>
          <span className="breadcrumb-separator">|</span>

          <span className="breadcrumb-link inactive">Add Category</span>
        </div>
      </div>

      <Container fluid className="p-4">
        <Card style={{ border: "none" }}>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row className="mb-4">
                <Col md={6} sm={12}>
                  <Form.Control
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Enter category name"
                  />
                  {errors.name && (
                    <div className="text-danger small mt-1">{errors.name}</div>
                  )}
                </Col>
              </Row>

              <Row>
                <Col className="d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="cancel-btn"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          animation="border"
                          size="sm"
                          variant="light"
                          className="me-2"
                        />
                        Submitting...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
